<script>
export default {
    name: 'IconArrowheadDown',
}
</script>
<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="base-icon icon-arrowhead-down" viewBox="0 0 64 64"><path fill="currentColor"  fill-rule="evenodd" d="M64 19.4 32.133 50 32 49.871l-.133.129L0 19.4 5.624 14 32 39.327 58.376 14 64 19.4Z" clip-rule="evenodd"/></svg>
</template>
